/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * RakeBack Wizard API
 * OpenAPI spec version: 1.0.0
 */
import { useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query'

import type { Faq } from '../models'

import faqListMutator from '../../client'

/**
 * API view to retrieve a list of active FAQs, ordered by priority.
Requires no authentication.
 */
export const faqList = (signal?: AbortSignal) => {
  return faqListMutator<Faq[]>({ url: `/api/v1/faq/`, method: 'GET', signal })
}

export const getFaqListQueryKey = () => {
  return [`/api/v1/faq/`] as const
}

export const getFaqListQueryOptions = <
  TData = Awaited<ReturnType<typeof faqList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof faqList>>, TError, TData>>
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getFaqListQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof faqList>>> = ({ signal }) =>
    faqList(signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof faqList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FaqListQueryResult = NonNullable<Awaited<ReturnType<typeof faqList>>>
export type FaqListQueryError = unknown

export function useFaqList<TData = Awaited<ReturnType<typeof faqList>>, TError = unknown>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof faqList>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof faqList>>,
        TError,
        Awaited<ReturnType<typeof faqList>>
      >,
      'initialData'
    >
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFaqList<
  TData = Awaited<ReturnType<typeof faqList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof faqList>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof faqList>>,
        TError,
        Awaited<ReturnType<typeof faqList>>
      >,
      'initialData'
    >
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFaqList<
  TData = Awaited<ReturnType<typeof faqList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof faqList>>, TError, TData>>
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useFaqList<
  TData = Awaited<ReturnType<typeof faqList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof faqList>>, TError, TData>>
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getFaqListQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getFaqListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof faqList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof faqList>>, TError, TData>>
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getFaqListQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof faqList>>> = ({ signal }) =>
    faqList(signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof faqList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FaqListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof faqList>>>
export type FaqListSuspenseQueryError = unknown

export function useFaqListSuspense<
  TData = Awaited<ReturnType<typeof faqList>>,
  TError = unknown,
>(options: {
  query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof faqList>>, TError, TData>>
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFaqListSuspense<
  TData = Awaited<ReturnType<typeof faqList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof faqList>>, TError, TData>>
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFaqListSuspense<
  TData = Awaited<ReturnType<typeof faqList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof faqList>>, TError, TData>>
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useFaqListSuspense<
  TData = Awaited<ReturnType<typeof faqList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof faqList>>, TError, TData>>
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getFaqListSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}
